module.exports = __webpack_public_path__ + "static/media/banner.8af4d16c.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/pageSecureSmartLock/banner.png
// module id = 650
// module chunks = 0